var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1156,
    cy: 25.1155,
    r: 25.1155,
    fill: "#F5E6D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2913 34.4756L37.6729 18.0939L34.4198 14.8408L21.2913 27.9694L14.6689 21.347L11.4158 24.6001L21.2913 34.4756Z",
    fill: "#F7943E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon_check.18920f0197d6d5571480be37f8efeff9.svg";
export { ForwardRef as ReactComponent };